import { render } from "./all-tahunan.vue?vue&type=template&id=5d3962c4"
import script from "./all-tahunan.vue?vue&type=script&lang=js"
export * from "./all-tahunan.vue?vue&type=script&lang=js"

import "./all-tahunan.vue?vue&type=style&index=0&id=5d3962c4&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__